import axios from "axios";
import { store } from "../store";
import {
  auth,
  baseUrl,
  googleProvider,
  facebookProvider
} from "../../firebaseConfig";
import { wordService } from "./wordService";
export const userService = {
  // getUsers,
  // loginWith,
  // updateProgressUser,
  // updateSavedWordsUser,
  // updateUser,

  // countLaws,
  // countWords,
  getUser,
  getLeaderBoard,
  startLesson,
  finishLesson,
  saveWord,
  unsaveWord,
  updateRules,
  updateWords,
  updateSentences,
  startGame,
  finishGame,
  addWordSuggestion,
  pay,
  cancelUpdate,
  nextLesson,
  userProgress,
  upcomingLesson,
};

const config = {
  headers: {
    "Content-Type": "text/plain"
  }
};

axios.defaults.xsrfCookieName = process.env.VUE_APP_CSRF_COOKIE_NAME
axios.defaults.xsrfHeaderName = "X-CSRFToken"
axios.defaults.withXSRFToken = true
axios.defaults.withCredentials = true;

// const apiUrl = "http://localhost:8000";
const apiUrl = process.env.VUE_APP_API_URL;
const accessToken = "";
const COURSE_ID = localStorage.getItem("courseNum");;

// Helpers

async function userProgress(user) {
  if (user && user.lessons) {
    return user.lessons
      .filter(lesson => lesson.is_done === true)
      .map(les => les.lesson.id);
  } else if (!user && window.localStorage.getItem("progress")) {
    return JSON.parse(atob(window.localStorage.getItem("progress")));
  } else {
    return [];
  }
}

async function nextLesson(user) {
  let userPermission = "unknown";
  if (user && !user.subscription_active) userPermission = "registered";
  if (user && user.subscription_active) userPermission = "paying";
  // if (store.getters.nextLesson.id) return store.getters.nextLesson
  const progress = await userProgress(user);
  console.log("PROGRESS", progress);
  const course = store.getters.course;
  console.log("COURSEEE", course);
  if (course && progress) {
    let result = [];
    for (const chap of course) {
      for (let sec of chap.section) {
        for (let les of sec.lesson) {
          if (
            les.game &&
            les.game.permission !== "unknown" &&
            userPermission == "unknown"
          )
            continue;
          if (
            les.game &&
            les.game.permission === "paying" &&
            userPermission === "registered"
          ) {
            continue;
          }
          result.push({ ...les, chapter: chap.id });
        }
      }
    }

    for (let n of result) {
      if (!progress.includes(n.id)) {
        return n;
        break;
      }
    }
    return {};
  } else {
    return {};
  }
}

function setNextChapter(chapter) {
  store.commit("setNextChapter", chapter);
}

function upcomingLesson(lessonId) {
  const course = store.getters.course;
  let found = false
  if (course) {
    for (let chap of course) {
      for (let sec of chap.section) {
        for (let i in sec.lesson) {
          // Finding current lesson
          if (sec.lesson[i].id == lessonId) {
            found = true
            continue;
          }
          // Searching for next lesson.
          else if (found) {
            setNextChapter(chap)
            return sec.lesson[i]
          }
        }
      }
    }
  }
  return null
}

// Get profile
async function getUser() {
  try {
    const res = await axios.get(
      `${apiUrl}/api/profile/me/?course_id=${COURSE_ID}`
    );
    if (res && res.data) {
      store.commit("setUser", res.data);
      store.commit("setIsLogged", true);
      // console.log("USERRR", res.data);
      // const lesson = await nextLesson(res.data);
      // console.log("LESSONNN", lesson);
      // store.commit("setNextLesson", lesson);
      return res.data;
    }
  } catch (err) {
    console.log(err);
  }
}



// Add Saved word
async function saveWord(wordId) {
  if (!wordId) return;
  try {
    const res = await axios.post(`${apiUrl}/api/profile/me/add_saved_word/`, {
      new_saved_word: wordId,
      course_id: COURSE_ID
    });
    if (res && res.data) {
      store.commit("setUser", res.data);
      return res.data;
    }
  } catch (err) {
    console.log(err);
  }
}

// Remove Saved word
async function unsaveWord(wordId) {
  try {
    const res = await axios.post(
      `${apiUrl}/api/profile/me/remove_saved_word/`,
      {
        word_to_remove: wordId,
        course_id: COURSE_ID
      }
    );
    if (res && res.data) {
      store.commit("setUser", res.data);
      return res.data;
    }
  } catch (err) {
    console.log(err);
  }
}

// Add word suggestion
async function addWordSuggestion(word_suggestion) {
  try {
    const res = await axios.post(
      `${apiUrl}/api/profile/me/add_word_suggestion/`,
      {
        word_suggestion: word_suggestion,
        course_id: COURSE_ID
      }
    );
    if (res && res.data) {
      return res.data;
    }
  } catch (err) {
    console.log(err);
  }
}

// Start lesson
async function startLesson(lessonId) {
  try {
    const res = await axios.post(`${apiUrl}/api/profile/me/start_lesson/`, {
      start_lesson_id: lessonId,
      course_id: COURSE_ID
    });
    if (res && res.data) return res.data;
  } catch (err) {
    console.log(err);
  }
}

// Finish lesson
async function finishLesson(lessonId, user) {
  // const lesson = await nextLesson(user);
  let lesson = upcomingLesson(lessonId);
  if (! lesson) {
    lesson = await nextLesson(user)
  }
  console.log("LESSONNN", lesson);
  store.commit("setNextLesson", lesson);
  if (user) {
    try {
      const res = await axios.post(`${apiUrl}/api/profile/me/finish_lesson/`, {
        finished_lesson_id: lessonId,
        course_id: COURSE_ID
      });
      if (res && res.data) {
        store.commit("setUser", res.data);
        return res.data;
      }
    } catch (err) {
      console.log(err);
    }
  } else {
    let progress = window.localStorage.getItem("progress");
    if (progress) {
      let newprogress = JSON.parse(atob(progress));
      newprogress.push(lessonId);
      window.localStorage.setItem(
        "progress",
        btoa(JSON.stringify(newprogress))
      );
    } else {
      window.localStorage.setItem("progress", btoa(JSON.stringify([lessonId])));
    }
  }
}
// Update rules
//[{"score": 0,"external_id": "string"}]

async function startGame(game_id) {
  try {
    const res = await axios.post(`${apiUrl}/api/profile/start_game/`, {
      game_id: game_id,
      course_id: COURSE_ID
    });
    if (res && res.data) return res.data;
  } catch (err) {
    console.log(err);
  }
}

async function finishGame(game_id) {
  try {
    const res = await axios.post(`${apiUrl}/api/profile/finish_game/`, {
      game_id: game_id,
      course_id: COURSE_ID
    });
    if (res && res.data) {
      store.commit("setUser", res.data);
      return res.data;
    }
  } catch (err) {
    console.log(err);
  }
}

async function updateRules(rules) {
  try {
    const res = await axios.post(
      `${apiUrl}/api/profile/me/update_known_rules/`,
      {
        new_known_rules: rules,
        course_id: COURSE_ID
      }
    );
    if (res && res.data) return res.data;
  } catch (err) {
    console.log(err);
  }
}

// Update words
//[{"score": 0,"external_id": "string"}]

async function updateWords(words) {
  try {
    const res = await axios.post(
      `${apiUrl}/api/profile/me/update_known_words/`,
      {
        new_known_words: words,
        course_id: COURSE_ID
      }
    );
    if (res && res.data) {
      store.commit("setUser", res.data);
      return res.data;
    }
  } catch (err) {
    console.log(err);
  }
}

// Update sentences
//[{"score": 0,"external_id": "string"}]

async function updateSentences(sentences) {
  try {
    const res = await axios.post(
      `${apiUrl}/api/profile/me/update_known_sentences/`,
      {
        new_known_sentences: sentences,
        course_id: COURSE_ID
      },
    );
    if (res && res.data) return res.data;
  } catch (err) {
    console.log(err);
  }
}

// Get profile
async function getLeaderBoard() {
  try {
    const res = await axios.get(
      `${apiUrl}/api/profile/leaderboard/?course_id=${COURSE_ID}`
    );
    if (res && res.data) return res.data;
  } catch (err) {
    console.log(err);
  }
}

// Get access token
async function pay(payment_id, token) {
  try {
    const res = await axios.post(`${apiUrl}/api/profile/create_payment/`, {
      payment_option_id: payment_id,
      ogtoken: token
    });
    if (res && res.data) {
      console.log(res.data);
      if (res.status == 200) await getUser();
      return res.data;
    }
  } catch (err) {
    return err;
  }
}

async function cancelUpdate() {
  try {
    const res = await axios.post(
      `${apiUrl}/api/profile/cancel_recurring_payment/`,
      {
        course: COURSE_ID
      }
    );
    if (res && res.data) {
      console.log(res.data);
      if (res.status == 200) await getUser();
      return res.data;
    }
  } catch (err) {
    return err;
  }
}

async function countWords(user, chaptersBefore) {
  console.log("COUNT WORDS");
  const words = await wordService.getWords(user);

  let counter = 0;
  // chapters.forEach(c => {
  //     c.words.forEach(w => {
  //         if (w.know >= 5) {
  //             counter++;
  //         }
  //     });
  // });
  words.forEach(w => {
    if (w.know >= 5) {
      counter++;
    }
  });
  return counter;
}

function countLaws(user) {
  let counter = 0;
  if (user.chapters) {
    user.chapters.forEach(c => {
      for (const key in c) {
        if (key === "id" || key === "words") continue;
        if (c[key] === 100) counter++;
      }
    });
  }
  return counter;
}



// WEBPACK FOOTER //
// ./src/services/userService.js